import React from 'react'
import SelectBox from '@/components/content/SelectBox'
import { OUTBOUNDS_STATUS } from '@/services/outbound/outboundSearch/consts'

interface Props {
  value?: string
  onChange: (v: string) => void
}

function SelectBoxStatus({ value, onChange }: Props) {
  // option API 대체 예정
  return <SelectBox block hasAll placeholder="출고상태를 선택해주세요" value={value} options={OUTBOUNDS_STATUS} onChange={onChange} />
}

export default SelectBoxStatus
